// @ts-expect-error Untyped
// TODO: determine if it is ok to use this shared httpClient here
import http from 'developer-docs-shared-components/lib/utils/httpClient';
const API_CATALOG_DOCUMENTATION_SEARCH = 'public/api/spec/v1/documentation/search/unified?q=';
export function fetchSearchResults(query, locale, offset) {
  return http.get(`${API_CATALOG_DOCUMENTATION_SEARCH}${query}&locale=${locale}${offset ? `&offset=${offset}` : ''}`);
}